var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.5H5.25C4.836 4.5 4.5 4.836 4.5 5.25C4.5 5.664 4.836 6 5.25 6H14.25C14.664 6 15 5.664 15 5.25C15 4.836 14.664 4.5 14.25 4.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H5.25C4.836 7.5 4.5 7.836 4.5 8.25C4.5 8.664 4.836 9 5.25 9H11.25C11.664 9 12 8.664 12 8.25C12 7.836 11.664 7.5 11.25 7.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H3C1.3455 0 0 1.3455 0 3V18C0 18.291 0.168 18.5565 0.432 18.6795C0.5325 18.726 0.642 18.75 0.75 18.75C0.9225 18.75 1.0935 18.69 1.23 18.576L5.5215 15H16.5C18.1545 15 19.5 13.6545 19.5 12V3C19.5 1.3455 18.1545 0 16.5 0ZM18 12C18 12.8265 17.328 13.5 16.5 13.5H5.25C5.0745 13.5 4.905 13.5615 4.77 13.674L1.5 16.3995V3C1.5 2.1735 2.172 1.5 3 1.5H16.5C17.328 1.5 18 2.1735 18 3V12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6C20.586 6 20.25 6.336 20.25 6.75C20.25 7.164 20.586 7.5 21 7.5C21.828 7.5 22.5 8.1735 22.5 9V21.6885L19.968 19.6635C19.836 19.5585 19.6695 19.5 19.5 19.5H9C8.172 19.5 7.5 18.8265 7.5 18V17.25C7.5 16.836 7.164 16.5 6.75 16.5C6.336 16.5 6 16.836 6 17.25V18C6 19.6545 7.3455 21 9 21H19.236L22.7805 23.8365C22.917 23.9445 23.0835 24 23.25 24C23.3595 24 23.4705 23.976 23.5755 23.9265C23.835 23.8005 24 23.538 24 23.25V9C24 7.3455 22.6545 6 21 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmChat);
export default __webpack_public_path__ + "static/media/sm_chat.81ae9b5006bb191d7bd8be755d663175.svg";
export { ForwardRef as ReactComponent };